import { combineReducers } from "redux";
import employeeFilesList from "./employeeFilesList";

const employeeFiles = combineReducers({
  employeeFilesList
});

export default employeeFiles;
